import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPhone = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<clipPath id="a"><path d="M0 0h32v32H0z" /></clipPath><g clipPath="url(#a)"><path fill="currentColor" d="M8 3.08 2.317 6.412v5.206c.445 3.08 3.08 7.048 7.048 11.016s7.937 6.603 11.016 7.048h5.206L28.921 24l-7.588-5.238L18 22.572c-3.08-1.747-6.825-5.493-8.571-8.572l3.81-3.333zM8.698 0l7.62 11.08-3.842 3.333a24.38 24.38 0 0 0 5.111 5.11l3.334-3.84L32 23.302 26.92 32h-6.73C13.905 32 0 18.095 0 11.81V5.08z" /></g></svg>;
export default SvgPhone;